export const incomingMailPathname = 'incoming-mail';
export const incomingMailFilePathname = 'incoming-mail-file-viewer';
